const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid", "gbraid", "wbraid"];

export function filterCampaign(search: string): string {
  const input = new URLSearchParams(search);
  const output = new URLSearchParams();
  for (const key of keys) {
    const value = input.get(key);
    if (value && value.length <= 256) output.set(key, value);
  }
  return output.toString();
}

export function campaignSearch(): string {
  if (typeof window === "undefined") return "";
  const current = filterCampaign(window.location.search);
  try {
    if (current) window.sessionStorage.setItem("socialcast_campaign", current);
    return current || filterCampaign(window.sessionStorage.getItem("socialcast_campaign") || "");
  } catch { return current; }
}
